export default __webpack_public_path__ + "static/media/returns-collapse.bc2fe58f.svg";